import { useNavigate } from 'react-router-dom';
import HataSayfasi, { HataButon } from './HataSayfasi';
import { IkonKilit } from '../../components/Ikonlar';

export default function Page401() {
  const navigate = useNavigate();

  return (
    <HataSayfasi
      kod="401"
      renk="indigo"
      ikon={<IkonKilit size={40} />}
      baslik="Oturumunuz Sona Erdi"
      aciklama={<>Güvenliğiniz için oturum kapatıldı ya da süresi doldu. Devam etmek için tekrar giriş yapın.</>}
      altYazi="Oturumlar belirli bir süre sonra kendiliğinden kapanır. Şifrenizi kimseyle paylaşmayın, ortak bilgisayarlarda işiniz bitince çıkış yapın."
      aksiyonlar={
        <>
          <HataButon onClick={() => navigate(-1)}>← Geri Dön</HataButon>
          <HataButon birincil onClick={() => navigate('/login')}>Giriş Yap</HataButon>
        </>
      }
    />
  );
}
